export const FEATURES = {
  opsPanels: import.meta.env.VITE_FE_OPS_PANELS === '1',
  resourcesApps: import.meta.env.VITE_FE_RES_APPS === '1',
  contextTemplates: import.meta.env.VITE_FE_CTX_TEMPLATES === '1',
  freezeStatus: import.meta.env.VITE_FE_FREEZE === '1',
  // GEN-08: App Generator (dev-only)
  appGenerator: import.meta.env?.DEV || localStorage.getItem('FEATURE_APP_GENERATOR') === 'true'
};

// Generator configuration
export const GENERATOR_CONFIG = {
  BASE_URL: import.meta.env?.VITE_GENERATOR_BASE_URL || "http://localhost:4070",
  POLL_MS: Number(import.meta.env?.VITE_GENERATOR_POLL_MS || 2000),
  ADMIN_TOKEN_KEY: 'GEN_ADMIN_TOKEN'
};
